export enum InstanceCountComparison {
  hasCountEqualTo = 0,
  hasCountGreaterThan = 1,
  hasCountLessThan = 2,
  hasCountGreaterOrEqualTo = 3,
  hasCountLessOrEqualTo = 4,
  isUpdated = 5,
  hadCountEqualTo = 6,
  hadCountNotEqualTo = 7,
  isBlank = 8,
  isPresent = 9,
  hasCountNotEqualTo = 10
}